export default import.meta.ROLLDOWN_FILE_URL_nF8fP3M$71Mt_SWg$jM6MA